// Constants.js contains constants used in the create formula menu.

import { appstr } from "@coreapp/utils/appstr";

export const OperatorList = [
  "add",
  "subtract",
  "multiply",
  "divide",
  "lookup",
  "split",
  "concatenate",
  "average",
  "count",
  "sum",
  "min",
  "max"
];

// TODO refactor using enum-like objects

export const FieldOptionsPlaceholder = "_FieldOptionsPlaceholder";

export const SubtractSchema = [
  {
    propertyName: "valueType",
    displayName: appstr("Treat value as"),
    dataType: "select",
    options: ["Number", "Date"],
    defaultValue: "Number"
  }
];

export const BasicMathSchema = [
  {
    displayName: appstr("Basic math operation"),
    dataType: "string",
    options: [],
    defaultValue: ""
  }
];

export const BaseLookupSchema = [
  {
    propertyName: "lookupUsing",
    displayName: appstr("Look up using"),
    dataType: "select",
    options: FieldOptionsPlaceholder,
    defaultValue: null,
    placeholder: appstr("None"),
    require: true
  },
  {
    propertyName: "matchUsing",
    displayName: appstr("Match using"),
    dataType: "select",
    options: FieldOptionsPlaceholder,
    defaultValue: null,
    placeholder: appstr("None"),
    require: true
  },
  {
    propertyName: "returnUsing",
    displayName: appstr("Return using"),
    dataType: "select",
    options: FieldOptionsPlaceholder,
    defaultValue: null,
    placeholder: appstr("None"),
    require: true
  }
];

export const BaseSplitSchema = [
  {
    propertyName: "fieldLookup",
    displayName: appstr("Field lookup"),
    dataType: "select",
    options: FieldOptionsPlaceholder,
    defaultValue: null,
    placeholder: appstr("None"),
    require: true
  },
  {
    propertyName: "separator",
    displayName: appstr("Separator"),
    dataType: "string",
    defaultValue: ","
  },
  {
    propertyName: "index",
    displayName: appstr("Index"),
    dataType: "integer",
    defaultValue: "0"
  }
];

export const BaseRuleSchema = {
  ruleType: "Equal",
  field: null,
  comparisonValue: "",
  staticRange: false
};

export const BaseConcatenateSchema = {
  type: "string",
  value: ""
};

export const CommonSelectProperties = {
  showCheck: false,
  setOpen: () => {},
  optionSize: "small",
  bold: true,
  selectSize: "small",
  triggerProps: {
    modifier: "secondary",
    size: "small"
  }
};

export const ScopeForward = {
  1: "2 Levels",
  2: "3 Levels",
  99: "All Levels"
};

export const ScopeInverse = {
  "2 Levels": 1,
  "3 Levels": 2,
  "All Levels": 99
};

// The default when "props" is missing should be "Equal"
export const RulePropsForward = {
  $gt: "Greater Than",
  $lt: "Less Than",
  $ne: "Not Equal",
  $in: "In",
  $nin: "Not In",
  "Date Bracket": "Date Bracket",
  $eq: "equal",
  $gte: "greaterequal",
  $lte: "lessequal"
};

export const RulePropsInverse = {
  "Greater Than": "$gt",
  "Less Than": "$lt",
  Equal: "", // special case
  "Not Equal": "$ne",
  In: "$in",
  "Not In": "$nin",
  "Date Bracket": "Date Bracket",
  "Greater Than or Equal": "$gte",
  "Less Than or Equal": "$lte"
};

export const fieldComparisons = [
  "equals",
  "notequal",
  "greater",
  "less",
  "greaterequal",
  "lessequal"
];

export const mappedFieldComparisons = {
  equals: "equal",
  notequal: "notequal",
  greater: "greater",
  less: "less",
  greaterequal: "greaterequal",
  lessequal: "lessequal"
};
